import { render, staticRenderFns } from "./questionnaireItem.vue?vue&type=template&id=2960b114"
import script from "./questionnaireItem.vue?vue&type=script&lang=js"
export * from "./questionnaireItem.vue?vue&type=script&lang=js"
import style0 from "./questionnaireItem.vue?vue&type=style&index=0&id=2960b114&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports